import React, { useEffect, useRef, useState } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import toast from "react-hot-toast";
import { logo, logo_Old } from "../assets/imgs";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import GroupWorkOutlinedIcon from "@mui/icons-material/GroupWorkOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import GpsFixedOutlinedIcon from "@mui/icons-material/GpsFixedOutlined";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import NotificationImportantOutlinedIcon from "@mui/icons-material/NotificationImportantOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import FactoryIcon from "@mui/icons-material/Factory";
import { URLS } from "../Services/Constant";
import { post } from "../Services/ApiHandler";

const SideBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const splitLocation = pathname.split("/");
  const [saideBarShow, setSaidBarShow] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));

  const [menuOpen, setMenuOpen] = useState(false);
  const [tripOpen, setTripOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleSidebar = () => {
    setSaidBarShow(!saideBarShow);
    setActiveMenu(null);
  };

  const handleMenuClick = (menuKey, defaultRoute) => {
    setSaidBarShow(true);
    setActiveMenu((prev) => (prev === menuKey ? null : menuKey));
    if (activeMenu !== menuKey && defaultRoute) {
      navigate(defaultRoute);
    }
  };

  //   const masterDrop = [
  //     "subscription",
  //     "property-management",
  //     "add-property-management",
  //     "transactions",
  //   ];

  const PostManagement = [
    "events",
    "trip",
    "sports",
    "events",
    "event-request",
    "events-request",
    "events-accept",
    "sports",
    "sports-request",
    "trip-request",
    "trip-proposal",
    "trip-requestid",
  ];

  const adminList = ["admin-list", "add-admin"];
  const roleList = ["role-list", "add-role"];

  const UserManagement = [
    "project-list",
    "material-list",
    "category-list",
    "attributes-list",
    "location",
    "warehouse-list",
  ];

  const wareHouseManagement = [
    "warehouse-material-list",
    "warehouse-material",
    "warehouse-material-view-projects",
    "warehouse-reserved-material",
    // "warehouse-mat-issue-view",
    "warehouse-mat-issue-list",
    "material-received-list",
    // "received-proj-req-view",
    // "received-proj-app-view",
    // "received-war-req-view",
    // "received-war-app-view",
    // "warehouse-mat-app-issue-view",
    // "reserved-mat-issue-view",
    // "warehouse-acc-issue-view",
    // "warehouse-req-issue-view",
    "material-received-create",
  ];
  const projectManagement = [
    "project-reserved-material",
    "project-reserved-mat-add",
    // "reserved-mat-issue-view",
    "reserved-mat-issue-list",
    "project-material-list",
    "project-Management",
    "project-reserved-material",
    // "reserved-mat-issue-view",
    "reserved-mat-issue-list",
    "project-material-received-list",
    // "project-received-proj-req-view",
    // "project-received-proj-app-view",
    // "project-received-war-req-view",
    // "project-received-war-app-view",
    // "project-req-issue-view",
  ];

  const Masters = ["categories", "promotion-plan", "promotion-planform"];

  useEffect(() => {
    if (Masters.includes(splitLocation[1])) {
      setActiveMenu("categories");
    }

    if (UserManagement.includes(splitLocation[1])) {
      setActiveMenu("general-user");
    }

    if (PostManagement.includes(splitLocation[1])) {
      setActiveMenu("events");
    }
  }, []);

  // Scroll to bottom when menu opens
  useEffect(() => {
    if (menuOpen && menuRef.current) {
      const el = menuRef.current;
      el.scrollTo({
        top: el.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [menuOpen]);

  const handleCloseMenu = () => {
    if (menuRef.current) {
      menuRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    setTimeout(() => setMenuOpen(false), 300); // wait for scroll then close
  };

  const handleLogout = () => {
    setLoading(true);
    // Simulated logout logic; replace with API call as needed
    post(URLS.LOGOUT)
      .then((res) => {
        // setBtn(false);
        if (res?.status == "success") {
          toast.success("Logout Successfully");
          localStorage.clear();
          setLoading(false);
          setPopup(false);
          navigate("/");

        }
      })
      .catch((err) => {
        // setBtn(false);
        console.log("err", err);
      });
  };

  return (
    <div className={`${saideBarShow ? " sidebar" : "close_sidebar  "} `}>
      <header>
        <div className="image_text pointer d-flex ac-jc">
          <div className="d-flex ac-js p-2 ">
            {saideBarShow ? (
              <img src={logo} className="logo" alt="logo" />
            ) : (
              <img src={logo_Old} className="logo-small" alt="logo" />
            )}
          </div>
        </div>
      </header>

      <div onClick={toggleSidebar}>
        {saideBarShow ? (
          <KeyboardArrowLeftIcon className="arrow-right" />
        ) : (
          <KeyboardArrowRightIcon className="arrow-left" />
        )}
      </div>

      <div className="menu_bar overflow-x-hidden overflow-scroll mt-2">
        <div className="menu">
          <ul className="menu_links ps-0">
            {givenpermissions?.includes("CAN-LIST-DASHBOARD") && (
              <li
                className="nav_link trans"
                onClick={() => navigate("/dashboard")}
              >
                <h4
                  className={`ps-2 ${splitLocation[1] === "dashboard" ? "f3 active_bar" : ""
                    } `}
                >
                  <DashboardCustomizeOutlinedIcon className="icon" />
                  <div className="d-flex ac-jb w-100">
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16 d-flex ac-jb w-100">
                      Dashboard
                    </span>
                  </div>
                </h4>
              </li>
            )}
            {givenpermissions?.includes("CAN-LIST-ROLE") && (
              <li
                className="nav_link trans"
                onClick={() => navigate("/role-list")}
              >
                <h4
                  className={`ps-2 ${roleList.includes(splitLocation[1]) ? "f3 active_bar" : ""
                    }`}
                >
                  {/* <img
                  src={
                    UserManagement.includes(splitLocation[1])
                      ? super_admin_icon
                      : "super_admin_icon_act"
                  }
                  className="icon"
                /> */}
                  <Groups2OutlinedIcon className="icon" />
                  <div className="d-flex ac-jb w-100">
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16 d-flex ac-jb w-100">
                      Roles
                    </span>
                  </div>
                </h4>
              </li>
            )}
            {givenpermissions?.includes("CAN-LIST-USER MANAGEMENT") && (
              <li
                className="nav_link trans"
                onClick={() => navigate("/admin-list")}
              >
                <h4
                  className={`ps-2 ${adminList.includes(splitLocation[1]) ? "f3 active_bar" : ""
                    }`}
                >
                  <AccountCircleIcon className="icon" />
                  <div className="d-flex ac-jb w-100">
                    <span
                      className={`${adminList.includes(splitLocation[1]) ? "active_bar" : ""} text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16 d-flex ac-jb w-100`}
                    >
                      User Management
                    </span>
                  </div>
                </h4>
              </li>
            )}
            {givenpermissions?.some(p => ["CAN-LIST-CATEGORY", "CAN-LIST-ATTRIBUTES", "CAN-LIST-MATERIAL", "CAN-LIST-LOCATION", "CAN-LIST-WAREHOUSE", "CAN-LIST-PROJECT"]?.includes(p)) && (
              <li
                className="nav_link trans"
                onClick={() =>
                  handleMenuClick("User-Management", givenpermissions?.includes("CAN-LIST-CATEGORY") ? "/category-list" : givenpermissions?.includes("CAN-LIST-ATTRIBUTES") ? "/attributes-list" : givenpermissions?.includes("CAN-LIST-MATERIAL") ? "/material-list" : givenpermissions?.includes("CAN-LIST-LOCATION") ? "/location" : givenpermissions?.includes("CAN-LIST-WAREHOUSE") ? "/warehouse-list" : givenpermissions?.includes("CAN-LIST-PROJECT") ? "/project-list" : "")
                }
              >
                <h4
                  className={`ps-2  ${UserManagement?.includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                    }`}
                >
                  <GroupWorkOutlinedIcon className="icon" />
                  <div className="d-flex ac-jb w-100">
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-15 d-flex ac-jb w-100">
                      Masters
                    </span>
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-15 d-flex justify-content-end mx-2 w-100">
                      {activeMenu === "User-Management" ? (
                        <KeyboardArrowUpOutlinedIcon />
                      ) : (
                        <KeyboardArrowDownOutlinedIcon />
                      )}
                    </span>
                  </div>
                </h4>
              </li>
            )}
            {activeMenu === "User-Management" && (
              <ul className="sub-menu show">
                {/* GENERAL USER */}
                {givenpermissions?.includes("CAN-LIST-CATEGORY") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/category-list")}
                  >
                    <h4
                      className={`${splitLocation[1] === "category-list" ||
                        splitLocation[1] === "add-category" ||
                        splitLocation[1] === "enquiry"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      <AccountCircleIcon className="icon" /> Category
                    </h4>
                  </li>
                )}
                {/* Trip-organizer */}
                {givenpermissions?.includes("CAN-LIST-ATTRIBUTES") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/attributes-list")}
                  >
                    <h4
                      className={`${splitLocation[1] === "attributes-list" ||
                        splitLocation[1] === "add-attributes"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      <AccountCircleIcon className="icon" /> Attributes
                    </h4>
                  </li>
                )}

                {givenpermissions?.includes("CAN-LIST-LOCATION") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/location")}
                  >
                    <h4
                      className={`${splitLocation[1] === "location" ||
                        splitLocation[1] === "add-location"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      <GpsFixedOutlinedIcon className="icon" /> Location
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes("CAN-LIST-WAREHOUSE") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/warehouse-list")}
                  >
                    <h4
                      className={`${splitLocation[1] === "warehouse-list" ||
                        splitLocation[1] === "add-warehouse"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      <WarehouseIcon className="icon" /> Warehouse
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes("CAN-LIST-PROJECT") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/project-list")}
                  >
                    <h4
                      className={`${splitLocation[1] === "project-list" ||
                        splitLocation[1] === "add-project"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      <TaskOutlinedIcon className="icon" /> Project
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes("CAN-LIST-MATERIAL") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/material-list")}
                  >
                    <h4
                      className={`${splitLocation[1] === "material-list" ||
                        splitLocation[1] === "add-material"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      <ShoppingCartOutlinedIcon className="icon" /> Material
                    </h4>
                  </li>
                )}
              </ul>
            )}
            {/* <li
              className="nav_link trans"
              onClick={() =>
                handleMenuClick("transaction", "/transaction")
              }
            >
              <h4
                className={`ps-2 ${["transaction"].includes(
                  splitLocation[1],
                )
                  ? "f3 active_bar"
                  : ""
                  }`}
              >
                <SettingsOutlinedIcon className="icon" />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16 d-flex ac-jb w-100">
                  Transaction
                </span>
              </h4>
            </li> */}
            {givenpermissions?.some(p => ["CAN-LIST-WAREHOUSE MANAGEMENT MATERIAL LIST", "CAN-LIST-WAREHOUSE MANAGEMENT RESERVED MATERIAL", "CAN-LIST-WAREHOUSE MANAGEMENT MATERIAL RECEIVED", "CAN-LIST-WAREHOUSE MANAGEMENT MATERIAL ISSUED",].includes(p)) && (
              <li
                className="nav_link trans"
                onClick={() =>
                  handleMenuClick(
                    "Warehouse-Management", givenpermissions?.includes("CAN-LIST-WAREHOUSE MANAGEMENT MATERIAL LIST") ? "/warehouse-material-list" : givenpermissions?.includes("CAN-LIST-WAREHOUSE MANAGEMENT RESERVED MATERIAL") ? "/warehouse-reserved-material" : givenpermissions?.includes("CAN-LIST-WAREHOUSE MANAGEMENT MATERIAL RECEIVED") ? "/material-received-list" : givenpermissions?.includes("CAN-LIST-WAREHOUSE MANAGEMENT MATERIAL ISSUED") ? "/warehouse-mat-issue-list" : "")
                }
              >
                <h4
                  className={`ps-2 ${wareHouseManagement.includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                    }`}
                >
                  <FactoryIcon className="icon" />
                  <div className="d-flex ac-jb w-100">
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16 d-flex ac-jb w-100">
                      Warehouse Management
                    </span>
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16 d-flex justify-content-end mx-2 w-100">
                      {activeMenu === "Warehouse-Management" ? (
                        <KeyboardArrowUpOutlinedIcon />
                      ) : (
                        <KeyboardArrowDownOutlinedIcon />
                      )}
                    </span>
                  </div>
                </h4>
              </li>
            )}
            {activeMenu === "Warehouse-Management" && (
              <ul className="sub-menu show">
                {/* GENERAL USER */}
                {givenpermissions?.includes("CAN-LIST-WAREHOUSE MANAGEMENT MATERIAL LIST") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/warehouse-material-list")}
                  >
                    <h4
                      className={`${splitLocation[1] === "warehouse-material-list" ||
                        splitLocation[1] === "warehouse-material" ||
                        splitLocation[1] === "warehouse-material-view-projects"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      {/* <AccountCircleIcon className="icon" /> */}
                      <span className="icon">&nbsp;</span> Material List
                    </h4>
                  </li>
                )}
                {/* Trip-organizer */}
                {givenpermissions?.includes("CAN-LIST-WAREHOUSE MANAGEMENT RESERVED MATERIAL") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/warehouse-reserved-material")}
                  >
                    <h4
                      className={`${splitLocation[1] === "warehouse-reserved-material"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      <span className="icon">&nbsp;</span> Reserved Material
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes("CAN-LIST-WAREHOUSE MANAGEMENT MATERIAL RECEIVED") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/material-received-list")}
                  >
                    <h4
                      className={`${splitLocation[1] === "material-received-list" ||
                        splitLocation[1] === "received-proj-req-view" ||
                        splitLocation[1] === "received-proj-app-view" ||
                        splitLocation[1] === "received-war-req-view" ||
                        splitLocation[1] === "received-war-app-view" ||
                        splitLocation[1] === "material-received-create"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      <span className="icon">&nbsp;</span> Material Received
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes("CAN-LIST-WAREHOUSE MANAGEMENT MATERIAL ISSUED") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/warehouse-mat-issue-list")}
                  >
                    <h4
                      className={`${splitLocation[1] === "warehouse-mat-issue-list" ||
                        splitLocation[1] === "warehouse-mat-issue-view" ||
                        splitLocation[1] === "warehouse-mat-app-issue-view" ||
                        splitLocation[1] === "reserved-mat-issue-view" ||
                        splitLocation[1] === "warehouse-acc-issue-view" ||
                        splitLocation[1] === "warehouse-req-issue-view" ||
                        splitLocation[1] === "warehouse-acc-issue-view"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      <span className="icon">&nbsp;</span> Material Issued
                    </h4>
                  </li>
                )}
              </ul>
            )}
            {givenpermissions?.some(p => ["CAN-LIST-PROJECT MANAGEMENT MATERIAL LIST", "CAN-LIST-PROJECT MANAGEMENT RESERVED MATERIAL", "CAN-LIST-PROJECT MANAGEMENT MATERIAL RECEIVED", "CAN-LIST-PROJECT MANAGEMENT MATERIAL ISSUED"]?.includes(p)) && (
              <li
                className="nav_link trans"
                onClick={() =>
                  handleMenuClick(
                    "project-material-list",
                    givenpermissions?.includes("CAN-LIST-PROJECT MANAGEMENT MATERIAL LIST") ? "/project-material-list" : givenpermissions?.includes("CAN-LIST-PROJECT MANAGEMENT RESERVED MATERIAL") ? "/project-reserved-material" : givenpermissions?.includes("CAN-LIST-PROJECT MANAGEMENT MATERIAL RECEIVED") ? "/project-material-received-list" : givenpermissions?.includes("CAN-LIST-PROJECT MANAGEMENT MATERIAL ISSUED") ? "/reserved-mat-issue-list" : "")
                }
              >
                <h4
                  className={`ps-2  ${projectManagement.includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                    }`}
                >
                  <FactoryIcon className="icon" />
                  <div className="d-flex ac-jb w-100">
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16 d-flex ac-jb w-100">
                      Project Management
                    </span>
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16 d-flex justify-content-end mx-2 w-100">
                      {activeMenu === "project-material-list" ? (
                        <KeyboardArrowUpOutlinedIcon />
                      ) : (
                        <KeyboardArrowDownOutlinedIcon />
                      )}
                    </span>
                  </div>
                </h4>
              </li>
            )}
            {activeMenu === "project-material-list" && (
              <ul className="sub-menu show">
                {/* GENERAL USER */}
                {givenpermissions?.includes("CAN-LIST-PROJECT MANAGEMENT MATERIAL LIST") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/project-material-list")}
                  >
                    <h4
                      className={`${splitLocation[1] === "project-material-list" ||
                        splitLocation[1] === "project-material" ||
                        splitLocation[1] === "project-material-view-projects"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      {/* <AccountCircleIcon className="icon" /> */}
                      <span className="icon">&nbsp;</span> Material List
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes("CAN-LIST-PROJECT MANAGEMENT RESERVED MATERIAL") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/project-reserved-material")}
                  >
                    <h4
                      className={`${splitLocation[1] === "project-reserved-material" ||
                        splitLocation[1] === "project-reserved-mat-add"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      {/* <AccountCircleIcon className="icon" /> */}
                      <span className="icon">&nbsp;</span>Reserved Material
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes("CAN-LIST-PROJECT MANAGEMENT MATERIAL RECEIVED") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/project-material-received-list")}
                  >
                    <h4
                      className={`${splitLocation[1] === "project-material-received-list" ||
                        splitLocation[1] === "project-received-proj-req-view" ||
                        splitLocation[1] === "project-received-proj-app-view" ||
                        splitLocation[1] === "project-received-war-req-view" ||
                        splitLocation[1] === "project-received-war-app-view"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      <span className="icon">&nbsp;</span> Material Received
                    </h4>
                  </li>
                )}
                {/* Trip-organizer */}
                {givenpermissions?.includes("CAN-LIST-PROJECT MANAGEMENT MATERIAL ISSUED") && (
                  <li
                    className="nav_link trans my-2"
                    onClick={() => navigate("/reserved-mat-issue-list")}
                  >
                    <h4
                      className={`${splitLocation[1] === "reserved-mat-issue-list" ||
                        splitLocation[1] === "reserved-mat-issue-view" ||
                        splitLocation[1] === "project-req-issue-view"
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      <span className="icon">&nbsp;</span> Material Issued
                    </h4>
                  </li>
                )}
              </ul>
            )}

            {/*for sample dropdown menu */}
            {/* <li
              className="nav_link trans"
              onClick={() => {
                setTripOpen(false);
                handleMenuClick("Post-Management", "/events");
              }}
            >
              <h4
                className={`ps-2 ${PostManagement.includes(splitLocation[1])
                  ? "f3 active_bar"
                  : ""
                  }`}
              >
                <img
                  src={
                    PostManagement.includes(splitLocation[1])
                      ? "super_admin_icon"
                      : "super_admin_icon_act"
                  }
                  className="icon"
                />
                <div className="d-flex ac-jb w-100">
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16 d-flex ac-jb w-100">
                    Post Management
                  </span>
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16 d-flex justify-content-end mx-3 w-100">
                    {activeMenu === "Post-Management" ? (
                      <KeyboardArrowUpOutlinedIcon />
                    ) : (
                      <KeyboardArrowDownOutlinedIcon />
                    )}
                  </span>
                </div>
              </h4>
            </li>
            {activeMenu === "Post-Management" && (
              <ul className="sub-menu show">
                <li
                  className="nav_link trans my-0"
                  onClick={() => {
                    setTripOpen(false);
                    navigate("/events");
                  }}
                >
                  <h4
                    className={`${splitLocation[1] === "events" ||
                      splitLocation[1] === "events-request"
                      ? "f3 sub_active"
                      : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Events
                  </h4>
                </li>
                <li
                  className="nav_link trans my-0"
                  onClick={() => {
                    setTripOpen(false);
                    navigate("/sports");
                  }}
                >
                  <h4
                    className={`${splitLocation[1] === "sports" ||
                      splitLocation[1] === "sports-request"
                      ? "f3 sub_active"
                      : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Sports
                  </h4>
                </li>
                <div className="">
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      setTripOpen(
                        tripOpen === "trip-request" ? false : "trip-request"
                      );
                      navigate("/trip-request");
                    }}
                  >
                    <h4
                      className={`${["trip-request", "trip-proposal"].includes(
                        splitLocation[1]
                      )
                        ? "f3 sub_active"
                        : ""
                        } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      Trip
                    </h4>
                  </li>

                  {tripOpen === "trip-request" && (
                    <div className="d-flex as-je w-50">
                      <ul className="sub-menu show">
            <li
              className="nav_link trans my-0"
              onClick={() => navigate("/trip-request")}
            >
              <h4
                className={`${splitLocation[1] === "trip-request" ||
                  splitLocation[1] === "trip-requestid"
                  ? "f3 sub_active"
                  : ""
                  } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
              >
                Request
              </h4>
            </li>
            <li
              className="nav_link trans my-0"
              onClick={() => navigate("/trip-proposal")}
            >
              <h4
                className={`${splitLocation[1] === "trip-proposal" ||
                  splitLocation[1] === ""
                  ? "f3 sub_active"
                  : ""
                  } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
              >
                Proposal
              </h4>
            </li>
          </ul>
        </div>
                  )}
      </div>
    </ul>
  )
} */}
            {/*  */}

            {/* post mgmt */}

            {/* Promotion Managent */}
            {/* {givenpermissions?.includes("CAN-LIST-SETTINGS") && (
              <li
                className="nav_link trans"
                onClick={() =>
                  handleMenuClick("promotion-management", "/promotion-management")
                }
              >
                <h4
                  className={`ps-2 ${["promotion-management", "promotion"].includes(
                    splitLocation[1],
                  )
                    ? "f3 active_bar"
                    : ""
                    }`}
                >
                  <SettingsOutlinedIcon className="icon" />
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16 d-flex ac-jb w-100">
                    Settings
                  </span>
                </h4>
              </li>
            )} */}
            {/* promotion mgmt end */}

            {/* Notification start */}
            {/* <li
              className="nav_link trans"
              onClick={() => handleMenuClick("notification", "/notification")}
            >
              <h4
                className={`ps-2 ${["notification"].includes(splitLocation[1])
                  ? "f3 active_bar"
                  : ""
                  }`}
              >
                <NotificationImportantOutlinedIcon className="icon" />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16 d-flex ac-jb w-100">
                  Notification
                </span>
              </h4>
            </li> */}
            {/* notification end */}
          </ul>
        </div>
      </div>
      {/* Logout Button */}
      <div
        className="d-flex ac-js py-3 px-2 log_bot"
        onClick={() => setPopup(true)}
      >
        <PowerSettingsNewOutlinedIcon className="icon" />
        <h4 className="f4 fs-md-13 fs-xl-16 mb-0 ms-4 pointer">Logout</h4>
        {/* {menuOpen ? (
          <KeyboardArrowUpIcon
            className="arrow-down "
            onClick={handleCloseMenu}
          />
        ) : (
          <KeyboardArrowDownIcon
            className="arrow-down "
            onClick={() => setMenuOpen(true)}
          />
        )} */}
      </div>

      {/* Logout Confirmation Popup */}
      {
        popup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <h2 className="f4 mt-4 " style={{ color: "#813257" }}>
                Logout?
              </h2>
              <p className="f3 mt-4">Are you sure, want to Logout?!</p>
              <div className="d-flex ac-jb px-2 mt-5">
                <button onClick={() => setPopup(false)} className="add-btn w-40">
                  No
                </button>
                <button onClick={handleLogout} className="cancel-btn f2 w-40">
                  Yes
                </button>
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
};

export default SideBar;
